module.exports = __webpack_public_path__ + "img/more.31962dad.svg";